import React, {useState} from 'react';

import {Button, InputNumber, ModalPopup} from '@kit';

import {useCharacter} from '../character-context';
import type {Coin} from '../model/character-state';
import {changeCoins, COIN_ORDER, COIN_SHORT_TITLES, COIN_TITLES, totalInGold} from '../model/coins';
import {CoinIcon} from './coin-icon';

import css from './sheet.module.css';

const formatGold = (value: number) => `${value.toLocaleString('ru')} ЗМ`;

export const CoinsBlock: React.FC = () => {
	const {state} = useCharacter();
	const [isOpen, setOpen] = useState(false);
	const ownedCoins = COIN_ORDER.filter((coin) => state.coins[coin] > 0);
	const visibleCoins: Coin[] = ownedCoins.length ? ownedCoins : ['gp'];

	return (
		<>
			<button type="button" className={css.coinsPlate} title="Изменить деньги" onClick={() => setOpen(true)}>
				{visibleCoins.map((coin) => (
					<span key={coin} className={css.coinCount} title={COIN_TITLES[coin]}>
						<CoinIcon coin={coin} size={20} />
						{state.coins[coin] || 0}
					</span>
				))}
			</button>
			{isOpen && <CoinsModal onClose={() => setOpen(false)} />}
		</>
	);
};

const CoinsModal: React.FC<{onClose(): void}> = ({onClose}) => {
	const {state, update} = useCharacter();
	const [amounts, setAmounts] = useState<Partial<Record<Coin, number>>>({});
	const hasAmounts = COIN_ORDER.some((coin) => amounts[coin]);

	const apply = (sign: 1 | -1) => {
		update((current) => ({coins: changeCoins(current.coins, amounts, sign)}));
		setAmounts({});
	};

	return (
		<ModalPopup open onClose={onClose} header="Деньги" maxWidth={480}>
			<div className={css.coinsTotal}>
				Всего в золотых: <b>{formatGold(totalInGold(state.coins))}</b>
			</div>
			<ul className={css.rows}>
				{COIN_ORDER.map((coin) => (
					<li key={coin} className={css.coinRow}>
						<CoinIcon coin={coin} />
						<span className={css.coinTitle}>{COIN_TITLES[coin]}</span>
						<b>{state.coins[coin] || 0}</b>
					</li>
				))}
			</ul>
			<div className={css.coinInputs}>
				{COIN_ORDER.map((coin) => (
					<label key={coin} className={css.coinInput}>
						<span className={css.statLabel}>
							<CoinIcon coin={coin} size={16} /> {COIN_SHORT_TITLES[coin]}
						</span>
						<InputNumber
							min={0}
							placeholder="0"
							value={amounts[coin] ?? null}
							onChange={(value) => setAmounts((current) => ({...current, [coin]: value || 0}))}
						/>
					</label>
				))}
			</div>
			<div className={css.modalButtons}>
				<Button disabled={!hasAmounts} onClick={() => apply(-1)}>
					Удалить
				</Button>
				<Button appearance="primary" disabled={!hasAmounts} onClick={() => apply(1)}>
					Добавить
				</Button>
			</div>
		</ModalPopup>
	);
};
